// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer_34MIq","footerInner":"index_footerInner_16UCF","logo":"index_logo_vpH0g"};